module.exports = __webpack_public_path__ + "static/Last-Mile-Delivery-Automation-dfcac9f7f459f287a9251be484ac30c7.jpg";